import { render, staticRenderFns } from "./GenericTableInvoice.vue?vue&type=template&id=11622d50"
import script from "./GenericTableInvoice.vue?vue&type=script&lang=js"
export * from "./GenericTableInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports